import React from "react";

export default function SSection(props) {
  return (
    <div className="flex flex-col sm:items-start items-center sm:text-start text-center gap-y-4">
      <div>
        <img
          src={props.img}
          alt="logo-1"
          className="max-w-[56px]"
        />
      </div>
      <h4 className="font-bold text-2xl">{props.title}</h4>
      <p className="font-normal text-base text-black text-opacity-60 leading-tight">
        {props.text}
      </p>
    </div>
  );
}
